import { caseStatusLabel, prettifySlug } from './caseStatus';

type Payload = Record<string, unknown> | null | undefined;
const str = (v: unknown) => (typeof v === 'string' && v ? v : '');

const CHANNEL: Record<string, string> = { phone: 'phone', telegram: 'Telegram', email: 'email', in_person: 'in person' };

/** Cases list "Last activity" line (design `act`): "Escalated to counselor", "Parent contacted by phone". */
export function activityTitle(kind: string, payload: Payload): string {
  const p = payload ?? {};
  switch (kind) {
    case 'note': return 'Note added';
    case 'nudge_sent': return 'Nudge sent to student';
    case 'escalated_to_counselor': return 'Escalated to counselor';
    case 'escalated_to_admin': return 'Escalated to admin';
    case 'parent_contacted': {
      const ch = CHANNEL[str(p.channel)];
      return ch ? `Parent contacted by ${ch}` : 'Parent contacted';
    }
    case 'status_changed': return str(p.to) ? `Status changed to ${caseStatusLabel(str(p.to)).toLowerCase()}` : 'Status changed';
    case 'outcome_recorded': return str(p.outcome) ? `Resolved: ${prettifySlug(str(p.outcome)).toLowerCase()}` : 'Resolved';
    case 'assignment_created': return p.exam_id != null ? `Assigned exam #${String(p.exam_id)}` : 'Assigned exam';
    default: return prettifySlug(kind) || 'Activity';
  }
}

/** Case timeline entry heading (design `title`): "Escalated to counselor", "Sent message: Keep going!". */
export function timelineTitle(kind: string, payload: Payload): string {
  const p = payload ?? {};
  switch (kind) {
    case 'note': return 'Note';
    case 'nudge_sent': return str(p.title) ? `Sent message: ${str(p.title)}` : 'Sent message';
    case 'escalated_to_counselor': return 'Escalated to counselor';
    case 'escalated_to_admin': return 'Escalated to admin';
    case 'parent_contacted': return 'Parent contacted';
    case 'status_changed': return 'Status changed';
    case 'outcome_recorded': return 'Case resolved';
    case 'case_opened': return 'Case opened';
    case 'assignment_created': return p.exam_id != null ? `Assigned exam #${String(p.exam_id)}` : 'Assigned exam';
    default: return prettifySlug(kind) || 'Activity';
  }
}

const KNOWN = new Set(['note', 'nudge_sent', 'escalated_to_counselor', 'escalated_to_admin', 'parent_contacted', 'status_changed', 'outcome_recorded', 'assignment_created', 'case_opened']);
/** Event kinds with a designed heading; others render their own readable label. */
export const isKnownEventKind = (kind: string) => KNOWN.has(kind);
